/* eslint-disable */
import React from 'react';
import {
    TextField,
    Datagrid,
    ReferenceField,
    Create,
    Edit,
    Show,
    SimpleShowLayout,
} from 'react-admin';
import { ReadOnlyContext } from '../../lib/context/ReadOnlyContext';
import { SwList } from '../../lib/SwList';
import { useAzureADGroups } from '../../msal/useAzureADGroups';
import { ResearchModuleInputs } from './ResearchModuleInputs';
import { CloneButton } from '../../lib/wrappers/actions';

const ResearchModuleList = (props) => {
    const { canEditCourseAndModule } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditCourseAndModule}>
            <SwList {...props}>
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={
                        !canEditCourseAndModule ? false : undefined
                    }
                >
                    <TextField source="id" />
                    <TextField source="moduleCode" />
                    <TextField source="shortTitle" />
                    <ReferenceField
                        reference="ModuleType"
                        source="moduleTypeId"
                    >
                        <TextField source="description" />
                    </ReferenceField>
                    <ReferenceField reference="Status" source="statusId">
                        <TextField source="Title" />
                    </ReferenceField>
                    <CloneButton label="myroot.copy" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

const ResearchModuleShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="moduleCode" />
            <TextField source="shortTitle" />
            <TextField source="welshTitle" />
            <ReferenceField reference="ModuleType" source="moduleTypeId">
                <TextField source="description" />
            </ReferenceField>
            <TextField source="description" />
            <ReferenceField reference="Status" source="statusId">
                <TextField source="Title" />
            </ReferenceField>
            <ReferenceField reference="Faculty" source="facultyId">
                <TextField source="description" />
            </ReferenceField>
            <ReferenceField reference="FacultyGroup" source="departmentId">
                <TextField source="description" />
            </ReferenceField>
            <ReferenceField reference="FacultySubGroup" source="subjectId">
                <TextField source="description" />
            </ReferenceField>
            <ReferenceField reference="CreditValue" source="creditValueId">
                <TextField source="creditvalue" />
            </ReferenceField>
            <ReferenceField reference="CreditLevel" source="creditLevelId">
                <TextField source="Title" />
            </ReferenceField>
        </SimpleShowLayout>
    </Show>
);

const ResearchModuleCreate = (props) => (
    <Create {...props} redirect="edit">
        <ResearchModuleInputs />
    </Create>
);

const ResearchModuleEdit = (props) => (
    <Edit {...props} redirect="edit">
        <ResearchModuleInputs />
    </Edit>
);

export default {
    list: ResearchModuleList,
    show: ResearchModuleShow,
    create: ResearchModuleCreate,
    edit: ResearchModuleEdit,
};
